module.exports = __webpack_public_path__ + "img/machineLearningValuationResults.bca8b7ef.png";